export default __webpack_public_path__ + "static/media/logo.13173d69.svg";